"use client";
import { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";

export const TextGenerateEffect = ({
  words,
  className = "",
  delay = 0,
  showCursor = true,
}: {
  words: string;
  className?: string;
  delay?: number;
  showCursor?: boolean;
}) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const displayText = useTransform(rounded, (latest) =>
    words.slice(0, latest)
  );
  const [isAnimating, setIsAnimating] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(true);
      const controls = animate(count, words.length, {
        type: "tween",
        duration: words.length * 0.08,
        ease: "linear",
        onComplete: () => {
          setIsComplete(true);
          setTimeout(() => setIsAnimating(false), 100);
        }
      });
      return controls.stop;
    }, delay * 1000);
    
    return () => clearTimeout(timer);
  }, [words, delay]);

  return (
    <span className={className}>
      <motion.span>{displayText}</motion.span>
      {showCursor && isAnimating && !isComplete && (
        <motion.span
          animate={{ opacity: [1, 0] }}
          transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
          className="inline-block w-0.5 h-[0.9em] bg-current ml-0.5 align-middle"
        />
      )}
    </span>
  );
};